import Layer from './Layer';

// mapbox のスタイルで定義されている label
export default class MapboxLabels extends Layer {
    constructor() {
        const id = 'mapbox-labels';
        const layers = {};
        const paintOptions = {};

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            {
                id: 'mapbox-labels',
                layers: [
                    'country-label',
                    'state-label',
                    'settlement-major-label',
                    'settlement-minor-label',
                    'settlement-subdivision-label',
                    'airport-label',
                    'poi-label',
                    'water-point-label',
                    'water-line-label',
                    'natural-point-label',
                    'natural-line-label',
                    'waterway-label',
                    'road-label-simple',
                ],
                isShow: true
            },
        ];
        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    async add() {
        // mapbox のスタイルで定義してあるレイヤーは visibility を変更するだけ。
        this._elements
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', 'visible')
                );
            });
    }

    remove() {
        // mapbox のスタイルで定義してあるレイヤーは visibility を変更するだけ。
        this._elements
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', 'none')
                );
            });
    }
};


